import { View } from "react-native";
import { IconButton, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import InventoryText from "../../components/InventoryText";
import VariantOptions from "../../components/VariantOptions";
import { Combination } from "../../types";

type Props = {
  combination: Combination;
};

export default function CombinationItem({ combination }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  const { variantOptions, inventory } = combination;

  const options = variantOptions.map((vo) => vo.option);

  return (
    <View style={tailwind("flex-row items-center")}>
      <View style={tailwind("flex-1")}>
        <VariantOptions options={options} />
        <InventoryText inventory={inventory} />
      </View>
      <IconButton icon="menu-right" iconColor={colors.primary} />
    </View>
  );
}
